import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

const DASHBOARD_HEADER_SIZE_PX = 64;

interface DashboardSlice {
  bannerHeightPx: number;
}

const initialState: DashboardSlice = { bannerHeightPx: 0 } satisfies DashboardSlice;
const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setBannerHeightPx(state, action: PayloadAction<number>) {
      state.bannerHeightPx = action.payload;
    }
  },
  selectors: {
    selectFullHeaderHeightPx: (state) => state.bannerHeightPx + DASHBOARD_HEADER_SIZE_PX,
    selectBannerHeightPx: (state) => state.bannerHeightPx
  }
});

export const { setBannerHeightPx } = dashboardSlice.actions;
export const { selectFullHeaderHeightPx, selectBannerHeightPx } = dashboardSlice.selectors;
export { DASHBOARD_HEADER_SIZE_PX };
export default dashboardSlice.reducer;
